import React from "react";

export default function CenterAlignmentIcon(props) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 6.24 6.24"
      enableBackground="new 0 0 6.24 6.24"
    >
      <path
        fill={props.color}
        d="m0,.48v-0.48h6.24v0.48h-6.24zm0,3.84v-0.48h6.24v0.48h-6.24zm1.44-1.92v-0.48h3.36v0.48h-3.36zm0,3.84v-0.479h3.36v0.479h-3.36z"
      />
    </svg>
  );
}
